
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LocationList from "../Components/Location";
import MachineMasterList from "../Components/MachineMasterList";
import API from "../Services/MachineMaster";
import API1 from "../Services/Product";
import API2 from "../Services/Location";

const MachineMaster = () => {
    const [locationId, setLocationId] = useState("");
    const [productTypes, setProductTypes] = useState([]);
    const [products, setProducts] = useState([]);
    const [animation, setAnimation] = useState([]);
    const [machineType, setMachineType] = useState([]);

    const [selectedProductType, setSelectedProductType] = useState("");
    const [selectedProduct, setSelectedProduct] = useState("");
    const [machineName, setMachineName] = useState("");
    const [machineId, setMachineId] = useState("");
    const [selectedColor, setSelectedColor] = useState("");
    const [selectedAnimation, setSelectedAnimation] = useState("");

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (locationId) {
            fetchProductTypes(locationId);
        } else {
            setProductTypes([]);
            setSelectedProductType("");
            setProducts([]);
            setSelectedProduct("");
        }
    }, [locationId]);

    useEffect(() => {
        fetchAnimation();
        fetchColor();
        if (selectedProductType) {
            fetchProducts(selectedProductType);
        } else {
            setProducts([]);
            setSelectedProduct("");
        }
    }, [selectedProductType]);

    // const fetchProductTypes = async (locId) => {
    //     try {
    //         const response = await API2.getLocationBaseData(locId);
    //         const details = response?.data?.data;
    //         console.log(' response?.data?.data response?.data?.data', response?.data?.data)
    //         setProductTypes(details?.product_type || []);
    //     } catch (error) {
    //         handleApiError(error, "Failed to fetch Product Types.");
    //     }
    // };

    const fetchProductTypes = async (locId) => {
    try {
        const response = await API2.getLocationBaseData(locId);
        const allProducts = response?.data?.data?.product_type || [];
       
        const filteredProducts = allProducts.filter(product => product.is_combo === false);

        console.log("Filtered Products (is_combo false):", filteredProducts);
        setProductTypes(filteredProducts); // Or whatever state you want to update
    } catch (error) {
        handleApiError(error, "Failed to fetch Product Types.");
    }
};


    const fetchAnimation = async () => {
        try {
            const response = await API.GetAnimation();
            const details = response?.data;
            setAnimation(details?.animation || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Animation list.");
        }
    };

    const fetchColor = async () => {
        try {
            const response = await API.GetAnimation(); // Assumed same API for simplicity
            const details = response?.data;
            setMachineType(details?.machine_color || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Machine Colors.");
        }
    };

    const fetchProducts = async (productTypeId) => {
        try {
            const response = await API1.Get_Product({
                is_active: 1,
                product_type_id: productTypeId,
               
            });
            setProducts(response?.data?.data || []);
        } catch (error) {
            handleApiError(error, "Failed to fetch Products.");
        }
    };

    const handleApiError = (error, defaultMessage) => {
        if (error.response?.status === 403) {
            window.location.replace("/Login");
        } else if (error.response) {
            toast.error(`Error: ${error.response.data.message}`);
        } else {
            toast.error(defaultMessage);
        }
    };

    const validateFields = () => {
        const newErrors = {};
        if (!locationId) newErrors.locationId = "Location is required";
        if (!selectedProductType) newErrors.selectedProductType = "Product Type is required";
        if (!selectedProduct) newErrors.selectedProduct = "Product is required";
        if (!machineName.trim()) newErrors.machineName = "Machine Name is required";
        if (!machineId.trim()) newErrors.machineId = "Machine ID is required";
        if (!selectedColor) newErrors.selectedColor = "Color is required";
        if (!selectedAnimation) newErrors.selectedAnimation = "Animation is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;

        const payload = {
            machine_name: machineName,
            type: selectedColor,
            location_id: locationId,
            machine_id: machineId,
            animation: selectedAnimation,
            product_id: selectedProduct,
        };

        try {
            const response = await API.addMachine(payload);
            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error("Unexpected response from server.");
            }
        } catch (error) {
            handleApiError(error, "Failed to add machine.");
        }
    };

    const handleCancel = () => {
        window.location.reload();
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Add New Machine</h4>
                        <div className="forms-sample">
                            <div className="row">
                                {/* Location Dropdown */}
                                <div className="col-md-4">
                                    <LocationList
                                        selectedLocation={locationId}
                                        setSelectedLocation={(location) => {
                                            setLocationId(location);
                                            setErrors((prev) => ({ ...prev, locationId: "" }));
                                        }}
                                    />
                                    {errors.locationId && <small className="text-danger">{errors.locationId}</small>}
                                </div>

                                {/* Product Type Dropdown */}
                                <div className="col-md-4">
                                    <label>Product Type <span className="text-danger">*</span></label>
                                    <select
                                        className="form-select"
                                        value={selectedProductType}
                                        onChange={(e) => setSelectedProductType(e.target.value)}
                                    >
                                        <option value="">Select Product Type</option>
                                        {productTypes.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.selectedProductType && <small className="text-danger">{errors.selectedProductType}</small>}
                                </div>

                                {/* Product Dropdown */}
                                <div className="col-md-4">
                                    <label>Product <span className="text-danger">*</span></label>
                                    <select
                                        className="form-select"
                                        value={selectedProduct}
                                        onChange={(e) => setSelectedProduct(e.target.value)}
                                    >
                                        <option value="">Select Product</option>
                                        {products.map((product) => (
                                            <option key={product.id} value={product.id}>
                                                {product.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.selectedProduct && <small className="text-danger">{errors.selectedProduct}</small>}
                                </div>
                            </div>

                            <div className="row mt-3">
                                {/* Machine Name */}
                                <div className="col-md-3">
                                    <label>Machine Name <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={machineName}
                                        onChange={(e) => setMachineName(e.target.value)}
                                    />
                                    {errors.machineName && <small className="text-danger">{errors.machineName}</small>}
                                </div>

                                {/* Machine ID */}
                                <div className="col-md-3">
                                    <label>Machine ID <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={machineId}
                                        onChange={(e) => setMachineId(e.target.value)}
                                    />
                                    {errors.machineId && <small className="text-danger">{errors.machineId}</small>}
                                </div>

                                {/* Color */}
                                <div className="col-md-3">
                                    <label>Color <span className="text-danger">*</span></label>
                                    <select
                                        className="form-select"
                                        value={selectedColor}
                                        onChange={(e) => setSelectedColor(e.target.value)}
                                    >
                                        <option value="">Select Color</option>
                                        {machineType.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.selectedColor && <small className="text-danger">{errors.selectedColor}</small>}
                                </div>

                                {/* Animation */}
                                <div className="col-md-3">
                                    <label>Animation <span className="text-danger">*</span></label>
                                    <select
                                        className="form-select"
                                        value={selectedAnimation}
                                        onChange={(e) => setSelectedAnimation(e.target.value)}
                                    >
                                        <option value="">Select Animation</option>
                                        {animation.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.selectedAnimation && <small className="text-danger">{errors.selectedAnimation}</small>}
                                </div>
                            </div>

                            <div className="mt-4">
                                <button onClick={handleSubmit} className="btn btn-primary me-3">Submit</button>
                                <button onClick={handleCancel} className="btn btn-light">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <MachineMasterList />

        </div>
    );
};

export default MachineMaster;
